import { Mail } from '@mui/icons-material'
import React from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import KYCIndividual from "../../../PDF/Partner Offline Empanelment/KYC_Form_Individual.pdf";
import KYCNonIndividual from "../../../PDF/Partner Offline Empanelment/KYC_Form_Non-Individual.pdf";
import applEmpanel from "../../../PDF/Partner Offline Empanelment/Individual Empannelment Form.pdf"
import nonapplEmpanel from "../../../PDF/Partner Offline Empanelment/Non Individual Empannelment Form.pdf"
import nominationForm from "../../../PDF/Partner Offline Empanelment/Nomination-form-for-Distributor.pdf"
import mailBackLetter from "../../../PDF/Partner Offline Empanelment/Mail Back Letter.pdf"
import selfDeclIndiv from "../../../PDF/Partner Offline Empanelment/Self-Declaration-for-Individual.pdf"
import selfDeclNoSubBro from "../../../PDF/Partner Offline Empanelment/Self-declaration-for-corporate-brokers-with-no-sub-brokers.pdf"
import selfDeclSubBro from "../../../PDF/Partner Offline Empanelment/Self-declaration-for-corporate-brokers-with-sub-brokers.pdf"
import selfDeclARN from "../../../PDF/Partner Offline Empanelment/Self-Certification-by-the-ARN-Holder-who-is-sub-broker.pdf"
import salespromLit from "../../../PDF/Partner Offline Empanelment/Cofirmation-for-sales-promotional-literatures.doc"

function OfflineEmpanelment() {
  
    return (
        <>
            <div className="tab-pane fade show active" id="info" role="tabpanel" aria-label="Offline Empanelment">
                {/* <div className="container">
                    <div className="row">
                        <div className="col"> */}
                <Container>
                    <Row>
                        <Col sm={12}>

                            <div className="tab-wrapper distributer-h1">
                                <h2>Offline Empanelment</h2>

                                {/* <div className="red-box-container">
                                    <div className="red-box">Change in Registration Approval Process for NISM Certifications</div>
                                    <div className="red-box">AMFI Communication on Advertisement Guidelines</div>
                                </div> */}

                                <div className="forms-container">
                                    <div className="forms">
                                        <div className="particular">
                                            KYC Forms :
                                        </div>
                                        <div className="form-items">
                                            <div className="blue-box"><a href ={KYCIndividual} target="_blank" rel="noreferrer">KYC Individual</a></div>
                                            <div className="blue-box"><a href ={KYCNonIndividual} target="_blank" rel="noreferrer">KYC Non-Individual</a></div>
                                        </div>
                                    </div>

                                    {/* <div className="forms">
                                        <div className="particular">
                                            Empanelment related forms :
                                        </div>
                                        <div className="form-items">
                                            <div className="blue-box"><a href ={applEmpanel} target="_blank" rel="noreferrer">Individual Empanelment Form</a></div>
                                            <div className="blue-box"><a href ={nonapplEmpanel} target="_blank" rel="noreferrer">Non Individual Empanelment Form </a></div>
                                            <div className="blue-box"><a href ={nominationForm} target="_blank" rel="noreferrer">Nomination form for Distributor</a></div>
                                            <div className="blue-box"><a href ={mailBackLetter} target="_blank" rel="noreferrer">Mail Back Letter</a></div>
                                            <div className="blue-box"><a href ={selfDeclIndiv} target="_blank" rel="noreferrer">Self declaration for Individual</a></div>
                                            <div className="blue-box"><a href ={selfDeclNoSubBro} target="_blank" rel="noreferrer">Self declaration for corporate brokers with no sub brokers</a></div>
                                            <div className="blue-box"><a href ={selfDeclSubBro} target="_blank" rel="noreferrer">Self declaration for corporate brokers with sub brokers</a></div>
                                            <div className="blue-box"><a href ={selfDeclARN} target="_blank" rel="noreferrer">Self Certification by the ARN Holder who is sub-broker</a></div>
                                           
                                        </div>
                                    </div> */}

                                    <div className="forms">
  <h2 className="particular">
    Empanelment related forms :
  </h2>

  <ul className="form-items">
    <li className="blue-box">
      <a href={applEmpanel} target="_blank" rel="noopener noreferrer">
        Individual Empanelment Form
      </a>
    </li>

    <li className="blue-box">
      <a href={nonapplEmpanel} target="_blank" rel="noopener noreferrer">
        Non Individual Empanelment Form
      </a>
    </li>

    <li className="blue-box">
      <a href={nominationForm} target="_blank" rel="noopener noreferrer">
        Nomination form for Distributor
      </a>
    </li>

    <li className="blue-box">
      <a href={mailBackLetter} target="_blank" rel="noopener noreferrer">
        Mail Back Letter
      </a>
    </li>

    <li className="blue-box">
      <a href={selfDeclIndiv} target="_blank" rel="noopener noreferrer">
        Self declaration for Individual
      </a>
    </li>

    <li className="blue-box">
      <a href={selfDeclNoSubBro} target="_blank" rel="noopener noreferrer">
        Self declaration for corporate brokers with no sub brokers
      </a>
    </li>

    <li className="blue-box">
      <a href={selfDeclSubBro} target="_blank" rel="noopener noreferrer">
        Self declaration for corporate brokers with sub brokers
      </a>
    </li>

    <li className="blue-box">
      <a href={selfDeclARN} target="_blank" rel="noopener noreferrer">
        Self Certification by the ARN Holder who is sub-broker
      </a>
    </li>
  </ul>
</div>

                                    {/* <div className="forms">
                                        <div className="particular">
                                            KYD Forms :
                                        </div>
                                        <div className="form-items">
                                            <div className="blue-box">Individual KYDl</div>
                                            <div className="blue-box">Non Individual KYD</div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            <div className='Distributer-content'>
                                <div className='Distributer-content-inner'>
                                    <h2>How to become a Distributor?</h2>
                                    <p>In order for you to become one of our esteemed distributors,
                                        you will need to get yourself empanelled as an authorized Distributor for JM Financial Mutual Fund.</p>
                                </div>
                                <div className='list-content'>
                                    <h3>In order to empanel yourself with us, you need to carry out the following steps:</h3>
                                    <hr aria-hidden='true' role='presentation'></hr>
                                    <ul className='ul-list disc-li'>
                                        <li className='knowdi'>
                                            First, get your self-certified (if not previously certified) by The Association of Mutual Funds in India (AMFI),
                                            by taking the AMFI test programme. Clearing the AMFI test has been made mandatory by the Securities and Exchange
                                            Board of India (SEBI) and can be taken at different cities.
                                            For more details on the AMFI programme please visit <a href="https://www.amfiindia.com/" target='_blank' style={{color: "#0b5fff", textDecoration : "underline"}}>www.amfiindia.com</a>
                                        </li>
                                        <li className='knowdi'>
                                            After becoming AMFI certified by clearing the test, you will have to fill up an empanelment form which can be downloaded from this website,
                                            or simply email <a href="mailto:distributorcare@jmfl.com" style={{color: "#0b5fff", textDecoration : "underline"}}>distributorcare@jmfl.com</a> in order to obtain an empanelment form by mail.
                                        </li>
                                        <li className='knowdi'>
                                            The necessary documents required along with empanelment form are listed below.
                                        </li>
                                    </ul>
                                    <br></br>
                                    <h3>Empanelment as an Individual Distributor</h3>
                                    <hr aria-hidden='true' role='presentation'/>
                                    <p>In case of Individuals, the duly filled agency application form along with</p>
                                    <ul className='ul-list-diamond diamond-li'>
                                        <li >
                                            Self-Certified copy of ARN Card,
                                        </li>
                                        <li>
                                            Self-Certified copy of PAN Card and
                                        </li>
                                        <li>
                                            Self-certification form (Hard Copy, dully filled & signed)
                                        </li>
                                        <li>
                                            Nomination Form (optional but recommended)
                                        </li>
                                    </ul>
                                    <br></br>
                                    <h3>Empanelment as a Corporate Distributor</h3>
                                    <hr aria-hidden='true' role='presentation'></hr>
                                    <p>In case of Corporate Empanelment, the duly filled agency application form along with the following documents is required:</p>
                                    <ul className='ul-list disc-li'>
                                        <li className='knowdi'>
                                            Self-Certified Copy of Memorandum & Articles of association in the case of companies,
                                            partnership deed in the case of partnership firms,
                                            society registration documents in the case of societies and trust deed in the case of trusts
                                        </li>
                                        <li className='knowdi'>
                                            Self-Certified Copy of Board resolution and list of authorized signatories name & signature
                                        </li>
                                        <li className='knowdi'>
                                            Self-Certified Copy of AMFI ARN certificate of registration / ARN Card issued in name of Company
                                        </li>
                                        <li className='knowdi'>
                                            Self-Certified Copy of PAN Card
                                        </li>
                                        <li className='knowdi'>
                                            Self-certification form (Hard Copy dully filled & signed along with company seal affixed)
                                        </li>
                                        <li className='knowdi'>
                                            List of people who are engaged in Mutual Fund sales business with their ARN Card copy.
                                        </li>
                                    </ul>
                                    <p className='knowdi'>
                                        These documents along with the empanelment form, duly filled, should be sent to any of the regional
                                        offices of JM Financial Mutual Fund from where the Distributor proposes to operate. After reviewing the form,
                                        the prospective Distributor will receive an empanelment letter and code number,
                                        along with all necessary material (forms, fact sheets, marketing material etc.)
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


        </>
    )
}

export default OfflineEmpanelment